/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class StagedRecordsSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected systemCode: string | null = null;
    protected stagedJobId: string | null = null;
    protected tenantKey: string | null = null;
    protected tableName: string | null = null;
    protected tableFilter: Core.PolicySectionTableFilterContainer | null = null;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('core.imports.job.staged');
    }

    protected async activate(params: { systemCode: string, stagedJobId: string, tenantKey: string, tableName: string, tableFilter: Core.PolicySectionTableFilterContainer, sectionTitle: string },
        routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.systemCode || !params?.stagedJobId || !params?.tenantKey || !params?.tableName) {
            throw new Error('Missing required parameters: systemCode, stagedJobIdentifier, tenantKey, or tableName');
        }

        this.systemCode = params.systemCode;
        this.stagedJobId = params.stagedJobId;
        this.tenantKey = params.tenantKey;
        this.tableName = params.tableName;
        this.tableFilter = params.tableFilter;

        if(!!params?.sectionTitle && routeConfig.navModel) {
            const title = this.i18n.tr('core:routes.imports.staged.$title', { display: params.sectionTitle });
            routeConfig.navModel.setTitle(title);
        }
    }



    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////


}
